import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdAdd } from 'react-icons/md';

const NewCall: React.FC<IconBaseProps> = (props) => <MdAdd {...props} />;

export default NewCall;
